"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconMail', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 3C1.44772 3 1 3.44772 1 4V12C1 12.5523 1.44772 13 2 13H14C14.5523 13 15 12.5523 15 12V4C15 3.44772 14.5523 3 14 3H2ZM3 6.2806V11H13V6.28066L8.62473 9.78088C8.25951 10.0731 7.74056 10.0731 7.37534 9.78088L3 6.2806ZM11.3993 5H4.60081L8.00004 7.71938L11.3993 5Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M2 4C1.44772 4 1 4.44772 1 5V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V5C19 4.44772 18.5523 4 18 4H2ZM3 7.22894V15H17V7.22887L10.5812 11.8137C10.2335 12.0621 9.76641 12.0621 9.41872 11.8137L3 7.22894ZM15.2795 6H4.72042L9.99996 9.7711L15.2795 6Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M2.00006 4C1.44778 4 1.00006 4.44771 1.00006 5L1.00006 19C1.00006 19.5523 1.44778 20 2.00006 20L22.0001 20C22.5523 20 23.0001 19.5523 23.0001 19L23.0001 5C23.0001 4.44771 22.5523 4 22.0001 4L2.00006 4ZM4.62893 6L12.0001 11.7331L19.3713 6L4.62893 6ZM3.00006 7.26683L3.00006 18H21.0001V7.2669L12.614 13.7894C12.2529 14.0702 11.7473 14.0702 11.3862 13.7894L3.00006 7.26683Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M3.5 6C3.10218 6 2.72064 6.15804 2.43934 6.43934C2.15804 6.72064 2 7.10218 2 7.5V24.5C2 25.3284 2.67157 26 3.5 26H28.5C29.3284 26 30 25.3284 30 24.5V7.5C30 6.67157 29.3284 6 28.5 6H3.5ZM5 10.796L5 23H27V10.7961L16.9245 18.6813C16.3815 19.1063 15.6186 19.1063 15.0756 18.6813L5 10.796ZM24.4273 9L7.57279 9L16.0001 15.5953L24.4273 9Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;